export default {
  getList: {
    method: 'post',
    url: '/pp/selling-price/list'
  },
  add: {
    method: 'post',
    url: '/pp/selling-price'
  },
  delete: {
    method: 'delete',
    url: '/pp/selling-price'
  },
  update: {
    method: 'put',
    url: '/pp/selling-price/ID'
  },
  updatePatch: {
    method: 'patch',
    url: '/pp/selling-price/ID'
  },
  detail: {
    method: 'get',
    url: '/pp/selling-price/ID'
  }
}
